// ----------------------------------------------------------------------

// Define more types here
const FORMAT_PDF = ['pdf'];
const FORMAT_TEXT = ['txt'];
const FORMAT_PHOTOSHOP = ['psd'];
const FORMAT_WORD = ['doc', 'docx'];
const FORMAT_EXCEL = ['xls', 'xlsx'];
const FORMAT_ZIP = ['zip', 'rar', 'iso'];
const FORMAT_ILLUSTRATOR = ['ai', 'esp'];
const FORMAT_POWERPOINT = ['ppt', 'pptx'];
const FORMAT_AUDIO = ['wav', 'aif', 'mp3', 'aac'];
const FORMAT_IMG = ['jpg', 'jpeg', 'gif', 'bmp', 'png', 'svg'];
const FORMAT_VIDEO = ['m4v', 'avi', 'mpg', 'mp4', 'webm'];

const iconUrl = (icon) => `/assets/icons/files/${icon}.svg`;

// ----------------------------------------------------------------------

export function fileFormat(fileTypeOrUrl) {
  console.log('fileFormat', fileTypeOrUrl || 'NA');

  let format;

  switch (fileTypeOrUrl?.includes(fileTypeByTypeOrUrl(fileTypeOrUrl))) {
    case FORMAT_TEXT.includes(fileTypeByTypeOrUrl(fileTypeOrUrl)):
      format = 'txt';
      break;
    case FORMAT_ZIP.includes(fileTypeByTypeOrUrl(fileTypeOrUrl)):
      format = 'zip';
      break;
    case FORMAT_AUDIO.includes(fileTypeByTypeOrUrl(fileTypeOrUrl)):
      format = 'audio';
      break;
    case FORMAT_IMG.includes(fileTypeByTypeOrUrl(fileTypeOrUrl)):
      format = 'image';
      break;
    case FORMAT_VIDEO.includes(fileTypeByTypeOrUrl(fileTypeOrUrl)):
      format = 'video';
      break;
    case FORMAT_WORD.includes(fileTypeByTypeOrUrl(fileTypeOrUrl)):
      format = 'word';
      break;
    case FORMAT_EXCEL.includes(fileTypeByTypeOrUrl(fileTypeOrUrl)):
      format = 'excel';
      break;
    case FORMAT_POWERPOINT.includes(fileTypeByTypeOrUrl(fileTypeOrUrl)):
      format = 'powerpoint';
      break;
    case FORMAT_PDF.includes(fileTypeByTypeOrUrl(fileTypeOrUrl)):
      format = 'pdf';
      break;
    case FORMAT_PHOTOSHOP.includes(fileTypeByTypeOrUrl(fileTypeOrUrl)):
      format = 'photoshop';
      break;
    case FORMAT_ILLUSTRATOR.includes(fileTypeByTypeOrUrl(fileTypeOrUrl)):
      format = 'illustrator';
      break;
    default:
      format = fileTypeByTypeOrUrl(fileTypeOrUrl);
  }

  return format;
}

// ----------------------------------------------------------------------

export function fileThumb(fileUrl) {
  let thumb;

  switch (fileFormat(fileUrl)) {
    case 'folder':
      thumb = iconUrl('ic_folder');
      break;
    case 'txt':
      thumb = iconUrl('ic_txt');
      break;
    case 'zip':
      thumb = iconUrl('ic_zip');
      break;
    case 'audio':
      thumb = iconUrl('ic_audio');
      break;
    case 'video':
      thumb = iconUrl('ic_video');
      break;
    case 'word':
      thumb = iconUrl('ic_word');
      break;
    case 'excel':
      thumb = iconUrl('ic_excel');
      break;
    case 'csv':
      thumb = iconUrl('ic_excel');
      break;
    case 'xlsx':
      thumb = iconUrl('ic_excel');
      break;
    case 'powerpoint':
      thumb = iconUrl('ic_power_point');
      break;
    case 'pdf':
      thumb = iconUrl('ic_pdf');
      break;
    case 'photoshop':
      thumb = iconUrl('ic_pts');
      break;
    case 'illustrator':
      thumb = iconUrl('ic_ai');
      break;
    case 'image':
      thumb = iconUrl('ic_img');
      break;
    default:
      thumb = iconUrl('ic_file');
  }
  return thumb;
}

// ----------------------------------------------------------------------

export function fileTypeByTypeOrUrl(fileTypeOrUrl = '') {
  console.log('fileTypeByTypeOrUrl', fileTypeOrUrl || 'NA');
  if (fileTypeOrUrl?.split('/').length === 2) {
    return fileTypeOrUrl?.split('/')[1];
  }
  return (fileTypeOrUrl && fileTypeOrUrl.split('.').pop()) || '';
}

// ----------------------------------------------------------------------

export function fileNameByUrl(fileUrl) {
  return fileUrl.split('/').pop();
}

// ----------------------------------------------------------------------

export function fileData(file) {
  // Url
  if (typeof file === 'string') {
    return {
      key: file,
      preview: file,
      name: fileNameByUrl(file),
      type: fileTypeByTypeOrUrl(file),
    };
  }

  // File
  return {
    key: file.preview,
    name: file.name,
    size: file.size,
    path: file.path,
    type: file.type,
    preview: file.preview,
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
  };
}
